<ngx-spinner></ngx-spinner>
<section class="promotional_sect login-page">
  <a routerLink="" class="cross-icon">
    <span class="icon-close"></span>
  </a>
  <div class="content_sect">
    <div class="content_text">
      <div class="content_box">
        <div class="left-content">
          <img src="assets/images/logo-white.svg" />
          <div class="login-info">
            <h2 class="mb-2 font-bold">Welcome to Intelligens</h2>
            <h4 class="mb-2 font-bold">
              Stream real shows. Real shows that matter
            </h4>
            <h6 class="content-desk mb-3">
              This is your new home for reality shows with no scripts and
              documentaries with no filters. At Intelligens, we are dedicated to
              bringing you content that is not only entertaining but will also
              offer you a look into worlds you didn't even know existed. Join us
              today and become a part of the Intelligens family.
            </h6>
          </div>
        </div>
        <form
          (ngSubmit)="signup(signupForm.valid)"
          #signupForm="ngForm"
          class="row m-0 right-login"
        >
          <div class="form-group position-relative col-12 col-md-6">
            <label>{{ "PERSONAL_INFO.PLACEHOLDER_NAME" | translate }}</label>
            <div class="field-icon">
              <span class="mdi mdi-account-outline"></span>
            </div>
            <input
              type="text"
              class="form-control text-fields-gray with-icon-field"
              placeholder="{{ 'PERSONAL_INFO.PLACEHOLDER_NAME' | translate }}"
              [(ngModel)]="model.name"
              name="name"
              #name="ngModel"
              pattern="^[a-zA-Z ]*$"
              required
              maxlength="60"
            />
            <div
              style="color: red"
              class="validation_div"
              *ngIf="name.errors && (name.dirty || signupForm.submitted)"
            >
              <p class="mb-0" *ngIf="name.errors.required">
                {{ "PERSONAL_INFO.NAME_REQUIRED" | translate }}
              </p>
              <p class="mb-0 red-text" *ngIf="name.errors.pattern">
                {{ "PERSONAL_INFO.INVALID_NAME" | translate }}
              </p>
            </div>
          </div>
          <div class="form-group position-relative col-12 col-md-6">
            <label>{{ "PERSONAL_INFO.DOB_LABEL" | translate }}</label>
            <div class="field-icon">
              <span class="mdi mdi-calendar-month-outline"></span>
            </div>
            <div class="w-100">
              <input
                name="dob"
                [(ngModel)]="model.date_of_birth"
                #dob="ngModel"
                [min]="minDate"
                [max]="maxDate"
                [matDatepicker]="picker"
                placeholder="{{ 'PERSONAL_INFO.PLACEHOLDER_DOB' | translate }}"
                class="date-input w-100 form-control with-icon-field"
                autocomplete="off"
                required
                readonly
                (click)="picker.open()"
              />
              <div class="date-icon">
                <mat-datepicker #picker></mat-datepicker>
              </div>
            </div>
            <div
              style="color: red"
              class="validation_div"
              *ngIf="dob.errors && (dob.dirty || signupForm.submitted)"
            >
              <p class="mb-0" *ngIf="dob.errors.required">
                {{ "PERSONAL_INFO.DOB_REQUIRED" | translate }}
              </p>
            </div>
          </div>

          <div
            class="form-group position-relative col-12 col-md-12"
            *ngIf="!showEmail"
          >
            <label> {{ "PERSONAL_INFO.EMAIL_LABEL" | translate }}</label>
            <div class="field-icon">
              <span class="mdi mdi-email-outline"></span>
            </div>
            <input
              type="email"
              class="form-control text-fields-gray with-icon-field"
              placeholder="{{ 'PERSONAL_INFO.PLACEHOLDER_EMAIL' | translate }}"
              [(ngModel)]="model.email"
              name="email"
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}$"
              #email="ngModel"
              maxlength="255"
              required
            />
            <div
              style="color: red"
              class="validation_div"
              *ngIf="email.errors && (email.dirty || signupForm.submitted)"
            >
              <p class="mb-0" *ngIf="email.errors.required">
                {{ "PERSONAL_INFO.EMAIL_REQUIRED" | translate }}
              </p>
              <p class="mb-0 red-text" *ngIf="email.errors.pattern">
                {{ "PERSONAL_INFO.ENTER_VALID_EMAIL" | translate }}
              </p>
            </div>
          </div>
          <div
            class="form-group position-relative col-12 col-md-12"
            *ngIf="showEmail"
          >
            <label> {{ "PERSONAL_INFO.EMAIL_LABEL" | translate }}</label>
            <div class="field-icon">
              <span class="mdi mdi-email-outline"></span>
            </div>
            <input
              type="email"
              class="form-control text-fields-gray with-icon-field"
              placeholder="{{ 'PERSONAL_INFO.PLACEHOLDER_EMAIL' | translate }}"
              [(ngModel)]="model.email"
              name="email"
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}$"
              #email="ngModel"
              maxlength="255"
              required
              readonly
            />
            <div
              style="color: red"
              class="validation_div"
              *ngIf="email.errors && (email.dirty || signupForm.submitted)"
            >
              <p class="mb-0" *ngIf="email.errors.required">
                {{ "PERSONAL_INFO.EMAIL_REQUIRED" | translate }}
              </p>
              <p class="mb-0 red-text" *ngIf="email.errors.pattern">
                {{ "PERSONAL_INFO.ENTER_VALID_EMAIL" | translate }}
              </p>
            </div>
          </div>

          <div class="form-group position-relative col-12 col-md-6 password-in">
            <label>
              {{ "PERSONAL_INFO.PLACEHOLDER_PASSWORD" | translate }}</label
            >
            <div class="field-icon">
              <span class="mdi mdi-lock-open-outline"> </span>
            </div>
            <div class="pass-ic">
              <span
                class="icon-eye-closed"
                (click)="changePasswordType('password')"
                [ngClass]="{
                  'icon-eye-icon': passwordType == 'password',
                  'icon-eye-closed': passwordType != 'password'
                }"
              ></span>
            </div>
            <input
              maxlength="30"
              minlength="6"
              type="{{ passwordType }}"
              class="form-control text-fields-gray with-icon-field"
              placeholder="{{
                'PERSONAL_INFO.PLACEHOLDER_PASSWORD' | translate
              }}"
              [(ngModel)]="model.password"
              name="password"
              #password="ngModel"
              required
            />
            <div
              style="color: red"
              class="validation_div"
              *ngIf="
                password.errors && (password.dirty || signupForm.submitted)
              "
            >
              <p class="mb-0" *ngIf="password.errors.required">
                {{ "PERSONAL_INFO.PASSWORD_REQUIRED" | translate }}
              </p>
              <p class="mb-0" *ngIf="password.errors.minlength">
                {{ "PERSONAL_INFO.MINLENGTH_PASSWORD" | translate }}
              </p>
            </div>
          </div>
          <div class="form-group position-relative col-12 col-md-6 password-in">
            <label>{{ "PERSONAL_INFO.CONFIRM_PWD_LABEL" | translate }}</label>
            <div class="field-icon">
              <span class="mdi mdi-lock-open-outline"> </span>
            </div>
            <div class="pass-ic">
              <span
                class="icon-eye-closed"
                (click)="changePasswordType('confirmPassword')"
                [ngClass]="{
                  'icon-eye-icon': confirmPasswordType == 'password',
                  'icon-eye-closed': confirmPasswordType != 'password'
                }"
              ></span>
            </div>
            <input
              maxlength="30"
              minlength="6"
              ngValidateEqual="password"
              reverse="false"
              type="{{ confirmPasswordType }}"
              class="form-control text-fields-gray with-icon-field"
              placeholder="{{
                'PERSONAL_INFO.PLACEHOLDER_CONFIRM_PASSWORD' | translate
              }}"
              [(ngModel)]="model.confirm_password"
              name="confirm_password"
              #confirm_password="ngModel"
              required
            />
            <div
              style="color: red"
              class="validation_div"
              *ngIf="
                (confirm_password.dirty ||
                  confirm_password.touched ||
                  signupForm.submitted) &&
                confirm_password.invalid
              "
            >
              <p
                class="mb-0"
                *ngIf="
                  confirm_password.hasError('notEqual') &&
                  password.valid &&
                  !confirm_password.errors.required &&
                  !confirm_password.errors.minlength
                "
              >
                {{ "PERSONAL_INFO.MISSMATCH_PASSWORD" | translate }}
              </p>
              <p class="mb-0" *ngIf="confirm_password.errors.required">
                {{ "PERSONAL_INFO.CONFIRM_PASSWORD_REQUIRED" | translate }}
              </p>
              <p class="mb-0" *ngIf="confirm_password.errors.minlength">
                {{ "PERSONAL_INFO.MINLENGTH_PASSWORD" | translate }}
              </p>
            </div>
          </div>
          <div class="form-group col-12 col-md-12">
            <label>{{ "PERSONAL_INFO.GENDER_LABEL" | translate }}</label>
            <mat-radio-group
              name="gender"
              [(ngModel)]="model.gender"
              required
              #gender="ngModel"
            >
              <mat-radio-button [value]="'male'">{{
                "PERSONAL_INFO.MALE" | translate
              }}</mat-radio-button>
              <mat-radio-button [value]="'female'">{{
                "PERSONAL_INFO.FEMALE" | translate
              }}</mat-radio-button>
            </mat-radio-group>
            <div
              style="color: red"
              class="validation_div"
              *ngIf="gender.errors && (gender.dirty || signupForm.submitted)"
            >
              <p class="mb-0" *ngIf="gender.errors.required">
                {{ "PERSONAL_INFO.GENDER_REQUIRED" | translate }}
              </p>
            </div>
          </div>
          <div class="form-group col-12 col-md-12 d-flex justify-content-center">
            <button
              class="btn btn-theme btn-login"
              href="javascript:void(0)"
              [disabled]="!signupForm.valid"
            >
              {{ "PERSONAL_INFO.SUBMIT" | translate }}
            </button>
          </div>
          <div class="my-4 bottom-signup text-center w-100">
            <span class="d-block">
              {{ "PERSONAL_INFO.ALREADY_HAVE_AN_ACCOUNT?" | translate }}</span
            >
            <a
              routerLink="/login"
              href="javascript:void(0)"
              class="text-primary"
              >{{ "PERSONAL_INFO.BACK_TO_LOGIN" | translate }}</a
            >
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
